<template>
  <div>
    <v-card style="margin-top: 250px">
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("Validasi") }}
      </v-card-title>

      <v-container>
        <v-form ref="formcariexport">
          <v-row>
             <v-col cols="12" sm="4">
              <v-text-field
                outlined
                dense
                maxlenght="16"
                v-bind:label="$t('HID')"
                item-text="HID"
                v-model="HID"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn color="primary" 
              @click="getData()"
              :disabled="!HID">Semakan Validasi 
            </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    

    <v-card color="rgba(217, 217, 217, 0.5)" class="mb-5">
      <v-row justify="center">
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                      <th class="text-left">No.</th>
                      <th class="text-left" width="1080">Keterangan</th>
                      <th></th>
                    </tr>
                </thead>
            <tbody>
                <tr v-for="(item, position, index) in listRalatValidasiTambahan" :key="index">
                    <td>
                        {{ position + 1 }}
                    </td>
                    <td> {{ item }} </td>
                </tr>
            </tbody>
            </template>
            <template v-slot:top>
            <v-toolbar flat style="background-color: #E2FF0E">
                <v-toolbar-title class='font-weight-black'>Post Validasi</v-toolbar-title>
            </v-toolbar>
            </template>
        </v-simple-table>
      </v-row>
    </v-card>
    </v-card>

    <Overlay v-show="showOverlay"/>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";

import validasiTambahan from "./validasiTambahan.js"
import Overlay from '../../components/Overlay'
const validation = new validasiTambahan();

export default {
  Name: "validasi",
  props: ['noHID'], 
  components: {
    Overlay
  },
  computed: {},
  setup() {},
  data: () => ({
   HID:'',
   dataHID:'',
   listRalatValidasiTambahan:'',
   showOverlay: false,
  }),
  mounted(){
  
    // if(this.noHID != ''){
    //   this.HID = this.noHID;
    //   this.getData();
    // }
    if (this.noHID === undefined) {
      //donothing
    } else {
      this.HID = this.noHID;
      this.getData();
    }

  },
  methods: {
    async getData(){
       try{   
              this.showOverlay = true;
              const res = await axios.post(`${process.env.VUE_APP_API_URL}/validation/getData`, {'HID': this.HID})
              
              this.dataHID = res.data.data;
              this.startValidation(this.dataHID);

                
          } catch (error) {
            this.showOverlay = false;
            console.log(error);
          }
    },
    async startValidation(dataHID){
      try{
        this.listRalatValidasiTambahan = await validation.semakanValidasiTambahan(dataHID);
        this.showOverlay = false;
        //console.log(this.listRalatValidasiTambahan)
      }catch(e){
        this.showOverlay = false;
        console.log("ralat :"+e)
        alert(e)
      }
      

    }
   


  },
};
</script>